import { Box } from '@primer/react';
import { Heading } from '@upright/ui/common/generic/components/primer-custom/heading';
import { Text } from '@upright/ui/common/generic/components/primer-custom/text';

interface Props {
  topicsConsidered: string[] | undefined;
}

export const TopicsConsidered = (props: Props) => {
  if (!props.topicsConsidered) {
    return <></>;
  }

  return (
    <Box mb={3}>
      <Heading fontSize="micro" sx={{ mb: 2 }}>
        Main topics considered in this category
      </Heading>
      <Text>
        <ul>
          {props.topicsConsidered.map(topic => (
            <li key={topic}>{topic}</li>
          ))}
        </ul>
      </Text>
    </Box>
  );
};
